document.addEventListener("DOMContentLoaded", function () {

  /* ============================================================
     COLLECTION CONFIGS
     ------------------------------------------------------------
     To add a new collection, copy one of the blocks below and
     change: name, path, allowedVariants, and (optionally) the
     onProductPage / onCollectionPage hooks.

     - name:             unique id, used for sessionStorage
     - path:             the collection URL path
     - allowedVariants:  product handle -> option groups allowlist
                         (a variant must match one value per group;
                          omit a product to allow everything)
     - onProductPage:    optional custom code for product pages
                         reached from this collection
     - onCollectionPage: optional custom code for the collection
                         page itself
     ============================================================ */

  var COLLECTIONS = [

    /* ----------------------------------------------------------
       COLLECTION: Nixa Crimson Corps
       ---------------------------------------------------------- */
    {
      name: "nixa",
      path: "/collections/nixa-crimson-corps",

      allowedVariants: {
        "dinkles-glide-marching-shoe": [["Black"]],
        "long-wristed-cotton-military": [["White"]],
        "total-stretch-body-tights": [["Suntan", "Coffee"]],
        "power-flex": [["Tan", "Umber"]],
        "elite-5-rifle": [["Silver Bolt"], ["White Leather Strap"]],
        "rifle-slings-kits": [["White"]],
        "rifle-bolts": [["Elite"], ["Silver"]],
        "sfive-worn-by-dci-champions": [["Black"]]
        // guard-max-bag-lite: all colors allowed, so omitted
      },

      // Custom: Total Stretch Body Tights - single image gallery
      onProductPage: function (pathname) {
        if (pathname !== this.path + "/products/total-stretch-body-tights") return;

        function cleanGallery() {
          document.querySelectorAll(
            ".flickity-button, .flickity-prev-next-button, .flickity-page-dots"
          ).forEach(function (el) {
            el.style.display = "none";
          });

          var thumbSlider = document.querySelector(
            "#productThumbSlider-template--25272931451190__main"
          );
          var thumbs = document.querySelectorAll(".product__thumb-item");

          if (thumbSlider && thumbs.length) {
            var lastThumb = thumbs[thumbs.length - 1];

            thumbs.forEach(function (thumb) {
              thumb.style.display = "none";
            });

            lastThumb.style.display = "block";
            lastThumb.style.position = "absolute";
            lastThumb.style.left = "0px";
            lastThumb.style.transform = "translateX(0%)";

            var thumbImage = lastThumb.querySelector("img");
            if (thumbImage) {
              thumbImage.style.setProperty("transform", "rotate(90deg)", "important");
              thumbImage.style.setProperty("object-fit", "contain", "important");
            }

            thumbSlider.style.transform = "none";

            if (thumbSlider.flickity) {
              thumbSlider.flickity("select", thumbs.length - 1);
            }
          }

          var mainSlider = document.querySelector(
            "#productMainSlider-template--25272931451190__main"
          );
          var mainSlides = document.querySelectorAll(
            "#productMainSlider-template--25272931451190__main .product__img-item"
          );

          if (mainSlides.length) {
            if (mainSlider && mainSlider.flickity) {
              mainSlider.flickity("select", mainSlides.length - 1);
            }
            mainSlides.forEach(function (slide, index) {
              slide.style.display = index === mainSlides.length - 1 ? "block" : "none";
            });
          }
        }

        setTimeout(cleanGallery, 300);
        setTimeout(cleanGallery, 800);
      },

      // Custom: replace Total Stretch main image on the collection page
      onCollectionPage: function () {
        function replaceTotalStretchCollectionImage() {
          var productCards = document.querySelectorAll(
            'a.product-img[href*="/products/total-stretch-body-tights"]'
          );

          productCards.forEach(function (card) {
            var newImage =
              "https://americanband.com/cdn/shop/files/a91_7256da74-959e-4cab-a398-04326b99ff96.jpg?v=1784045287&width=2376";

            var mainImage = card.querySelector(".image-wrapper img");
            if (mainImage) {
              mainImage.src = newImage;
              mainImage.setAttribute("src", newImage);
              mainImage.removeAttribute("srcset");
              mainImage.removeAttribute("data-src");
              mainImage.removeAttribute("data-srcset");
            }

            var hoverImages = card.querySelector(".product__slider");
            if (hoverImages) {
              hoverImages.style.display = "none";
            }
          });
        }

        setTimeout(replaceTotalStretchCollectionImage, 300);
        setTimeout(replaceTotalStretchCollectionImage, 1000);
      }
    }

    /* ----------------------------------------------------------
       COLLECTION: Missouri St Pride Color Guard
       ---------------------------------------------------------- */
    ,{
      name: "missouri-st-pride",
      path: "/collections/missouri-st-pride-color-guard",

      allowedVariants: {
        "elite-5-rifle": [["Black Bolt"], ["Black Leather Strap"]],
        "zaber": [["39\"", "39”", "39"]],
        "power-flex": [["Tan", "Umber"]],
        "total-stretch-body-tights": [["Suntan", "Coffee"]],
        "rifle-slings-kits": [["Black"], ["Elite"]],
        "rifle-bolts": [["Black"], ["Elite"]]
        // guard-max-bag-lite: all colors allowed, so omitted
      },

      // Custom: Total Stretch Body Tights - single image gallery
      onProductPage: function (pathname) {
        if (pathname !== this.path + "/products/total-stretch-body-tights") return;

        function cleanGallery() {
          document.querySelectorAll(
            ".flickity-button, .flickity-prev-next-button, .flickity-page-dots"
          ).forEach(function (el) {
            el.style.display = "none";
          });

          var thumbSlider = document.querySelector(
            "#productThumbSlider-template--25272931451190__main"
          );
          var thumbs = document.querySelectorAll(".product__thumb-item");

          if (thumbSlider && thumbs.length) {
            var lastThumb = thumbs[thumbs.length - 1];

            thumbs.forEach(function (thumb) {
              thumb.style.display = "none";
            });

            lastThumb.style.display = "block";
            lastThumb.style.position = "absolute";
            lastThumb.style.left = "0px";
            lastThumb.style.transform = "translateX(0%)";

            var thumbImage = lastThumb.querySelector("img");
            if (thumbImage) {
              thumbImage.style.setProperty("transform", "rotate(90deg)", "important");
              thumbImage.style.setProperty("object-fit", "contain", "important");
            }

            thumbSlider.style.transform = "none";

            if (thumbSlider.flickity) {
              thumbSlider.flickity("select", thumbs.length - 1);
            }
          }

          var mainSlider = document.querySelector(
            "#productMainSlider-template--25272931451190__main"
          );
          var mainSlides = document.querySelectorAll(
            "#productMainSlider-template--25272931451190__main .product__img-item"
          );

          if (mainSlides.length) {
            if (mainSlider && mainSlider.flickity) {
              mainSlider.flickity("select", mainSlides.length - 1);
            }
            mainSlides.forEach(function (slide, index) {
              slide.style.display = index === mainSlides.length - 1 ? "block" : "none";
            });
          }
        }

        setTimeout(cleanGallery, 300);
        setTimeout(cleanGallery, 800);
      },

      // Custom: replace Total Stretch main image on the collection page
      onCollectionPage: function () {
        function replaceTotalStretchCollectionImage() {
          var productCards = document.querySelectorAll(
            'a.product-img[href*="/products/total-stretch-body-tights"]'
          );

          productCards.forEach(function (card) {
            var newImage =
              "https://americanband.com/cdn/shop/files/a91_7256da74-959e-4cab-a398-04326b99ff96.jpg?v=1784045287&width=2376";

            var mainImage = card.querySelector(".image-wrapper img");
            if (mainImage) {
              mainImage.src = newImage;
              mainImage.setAttribute("src", newImage);
              mainImage.removeAttribute("srcset");
              mainImage.removeAttribute("data-src");
              mainImage.removeAttribute("data-srcset");
            }

            var hoverImages = card.querySelector(".product__slider");
            if (hoverImages) {
              hoverImages.style.display = "none";
            }
          });
        }

        setTimeout(replaceTotalStretchCollectionImage, 300);
        setTimeout(replaceTotalStretchCollectionImage, 1000);
      }
    }

    /* ----------------------------------------------------------
       COLLECTION: (next one goes here)
       ----------------------------------------------------------
    ,{
      name: "another-corps",
      path: "/collections/another-corps",
      allowedVariants: {
        "some-product-handle": [["Black"]],
        "another-product": [["Red", "Blue"]]
      }
      // onProductPage / onCollectionPage are optional
    }
    ---------------------------------------------------------- */

  ];


  /* ============================================================
     SHARED LOGIC - no need to edit below this line
     ============================================================ */

  var pathname = window.location.pathname;

  // Figure out which collection (if any) is active.
  // If the visitor lands on a restricted collection page, remember it.
  // If they later navigate to a product page, we look it up from storage.
  var activeCollection = null;

  COLLECTIONS.forEach(function (collection) {
    if (pathname.includes(collection.path)) {
      sessionStorage.setItem("activeRestrictedCollection", collection.name);
      activeCollection = collection;
    }
  });

  if (!activeCollection) {
    var storedName = sessionStorage.getItem("activeRestrictedCollection");
    if (storedName) {
      activeCollection = COLLECTIONS.find(function (c) {
        return c.name === storedName;
      }) || null;
    }
  }

  // Not on a restricted collection and didn't come from one: do nothing.
  if (!activeCollection) return;

  // ---- 1. Restrict product variants (allowlist) ----
  applyVariantRestrictions(activeCollection.allowedVariants || {});

  // ---- 2-8. Shared page cleanup ----
  applySharedCleanup();

  // ---- Per-collection custom hooks ----
  if (pathname.includes("/products/") && typeof activeCollection.onProductPage === "function") {
    activeCollection.onProductPage(pathname);
  }
  if (pathname === activeCollection.path && typeof activeCollection.onCollectionPage === "function") {
    activeCollection.onCollectionPage();
  }


  /* ------------------------------------------------------------
     Shared function: variant allowlist filtering
     ------------------------------------------------------------ */
  function applyVariantRestrictions(allowedVariants) {
    var pathParts = pathname.split("/");
    var currentHandle = pathParts[pathParts.indexOf("products") + 1];
    var allowedGroups = allowedVariants[currentHandle];
    if (!allowedGroups) return;

    var allValues = allowedGroups.flat();

    function filterVariants() {
      // Swatches / option buttons
      document.querySelectorAll("li.select-option, div[data-option1]").forEach(function (el) {
        var val = (el.getAttribute("data-value") || el.getAttribute("data-option1") || "").trim();
        if (!val) return;

        // Only filter option groups that contain at least one allowed value
        // (leaves size groups alone)
        var siblings = el.parentElement ? Array.from(el.parentElement.children) : [];
        var groupIsRestricted = siblings.some(function (s) {
          var v = (s.getAttribute("data-value") || s.getAttribute("data-option1") || "").trim();
          return allValues.includes(v);
        });

        if (groupIsRestricted && !allValues.includes(val)) {
          el.style.display = "none";
        }
      });

      // Variant dropdown: text must match one value from EVERY group
      var select = document.querySelector('select[name="id"]');
      if (select) {
        Array.from(select.options).forEach(function (option) {
          var text = option.textContent || "";
          var ok = allowedGroups.every(function (group) {
            return group.some(function (v) { return text.includes(v); });
          });
          if (!ok) {
            option.style.display = "none";
            option.disabled = true;
          }
        });
      }

      // After hiding, make sure the CURRENT selection is an allowed one.
      fixSelection();
    }

    /* Gallery / media containers. Elements inside these are IMAGES,
       not swatches, even if they carry data-option1 — clicking them
       opens the lightbox. Never auto-click anything in here. */
    var GALLERY_SELECTOR = [
      ".product__media",
      ".product__media-list",
      ".product__img-item",
      ".product__thumb-item",
      ".product__slider",
      ".product__photos",
      ".flickity-slider",
      ".flickity-viewport",
      ".product-gallery",
      "[data-photoswipe]",
      "[data-media-id]"
    ].join(", ");

    function isGalleryElement(el) {
      return !!el.closest(GALLERY_SELECTOR);
    }

    /* Checks whether a swatch element is currently marked as selected
       by the theme (covers the common patterns). */
    function isSwatchSelected(el) {
      if (el.matches(".active, .selected, .is-selected, [aria-selected='true'], [aria-checked='true']")) {
        return true;
      }
      var input = el.querySelector("input[type='radio'], input[type='checkbox']");
      return !!(input && input.checked);
    }

    /* Simulates a real click on a swatch so the theme's own JS runs
       (updates the variant id, price, images, etc.).
       Never clicks anchors that look like image/lightbox links. */
    function clickSwatch(el) {
      var input = el.querySelector("input[type='radio'], input[type='checkbox']");
      if (input) { input.click(); return; }

      var labelOrButton = el.querySelector("label, button");
      if (labelOrButton) { labelOrButton.click(); return; }

      var anchor = el.querySelector("a");
      var anchorIsImageLink =
        anchor &&
        (anchor.matches("[data-photoswipe], .photoswipe__link, [data-zoom], [data-lightbox]") ||
         /\.(jpg|jpeg|png|webp|gif)(\?|$)/i.test(anchor.getAttribute("href") || "") ||
         anchor.querySelector("img"));

      if (anchor && !anchorIsImageLink) { anchor.click(); return; }

      el.click();
    }

    var fixingSelection = false;

    /* Safety net: even if selection detection fails on some theme,
       never click the same option group more than a few times. */
    var groupClickAttempts = new WeakMap();
    var MAX_CLICK_ATTEMPTS = 3;

    function fixSelection() {
      // Guard: our own clicks cause DOM mutations, which re-trigger the
      // observer. This flag prevents an infinite loop.
      if (fixingSelection) return;
      fixingSelection = true;

      try {
        // ---- 1. Swatch groups: if the selected value in a restricted
        //         group is not allowed, click the first allowed one. ----
        var seenGroups = [];

        document.querySelectorAll("li.select-option, div[data-option1]").forEach(function (el) {
          // Gallery slides/thumbnails can carry data-option1 too.
          // They are images, not swatches — never click them.
          if (isGalleryElement(el)) return;

          var parent = el.parentElement;
          if (!parent || seenGroups.indexOf(parent) !== -1) return;
          seenGroups.push(parent);

          var children = Array.from(parent.children);

          var getVal = function (node) {
            return (node.getAttribute("data-value") || node.getAttribute("data-option1") || "").trim();
          };

          // Is this a restricted group (contains at least one allowed value)?
          var groupIsRestricted = children.some(function (c) {
            return allValues.includes(getVal(c));
          });
          if (!groupIsRestricted) return;

          var allowedInGroup = children.filter(function (c) {
            return allValues.includes(getVal(c));
          });
          if (!allowedInGroup.length) return;

          var selected = children.find(isSwatchSelected);
          var selectedIsAllowed = selected && allValues.includes(getVal(selected));

          // Nothing selected, or a hidden/disallowed value is selected:
          // click the first allowed value in this group.
          if (!selectedIsAllowed) {
            var attempts = groupClickAttempts.get(parent) || 0;
            if (attempts >= MAX_CLICK_ATTEMPTS) return;
            groupClickAttempts.set(parent, attempts + 1);
            clickSwatch(allowedInGroup[0]);
          }
        });

        // ---- 2. Variant dropdown: if the selected option is one we
        //         disabled, move to the first allowed option and fire
        //         a change event so the theme + add-to-cart sync up. ----
        var select = document.querySelector('select[name="id"]');
        if (select) {
          var current = select.options[select.selectedIndex];
          var currentOk =
            current &&
            !current.disabled &&
            allowedGroups.every(function (group) {
              return group.some(function (v) {
                return (current.textContent || "").includes(v);
              });
            });

          if (!currentOk) {
            var firstAllowed = Array.from(select.options).find(function (option) {
              if (option.disabled) return false;
              var text = option.textContent || "";
              return allowedGroups.every(function (group) {
                return group.some(function (v) { return text.includes(v); });
              });
            });

            if (firstAllowed) {
              select.value = firstAllowed.value;
              select.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }
        }
      } finally {
        // Release the guard on the next tick, after the theme has
        // reacted to our clicks/change events.
        setTimeout(function () { fixingSelection = false; }, 100);
      }
    }

    filterVariants();
    // Run again after the theme's own JS has initialized, in case it
    // sets a default (hidden) variant after we do.
    setTimeout(filterVariants, 300);
    setTimeout(filterVariants, 800);
    new MutationObserver(filterVariants).observe(document.body, { childList: true, subtree: true });
  }


  /* ------------------------------------------------------------
     Shared function: hide nav/search/logo/recommendations etc.
     (applies to every restricted collection)
     ------------------------------------------------------------ */
  function applySharedCleanup() {

    // Hide header menu
    var headerMenus = document.querySelector(".list-unstyled.header__menus");
    if (headerMenus) headerMenus.style.display = "none";

    // Hide color swatches
    function hideColorSwatches() {
      var elements = document.querySelectorAll(
        ".product-hover-options.color-swatch-desktop-true.color-swatch-mobile-false"
      );
      if (elements.length > 0) {
        elements.forEach(function (el) { el.style.display = "none"; });
        return true;
      }
      return false;
    }

    if (!hideColorSwatches()) {
      var swatchObserver = new MutationObserver(function (mutations, obs) {
        if (hideColorSwatches()) obs.disconnect();
      });
      swatchObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Hide search icon
    var searchEl = document.querySelector("a.header__icons-link.search");
    if (searchEl) searchEl.style.display = "none";

    // Hide mobile nav list
    var mobileNavList = document.querySelector(".list-unstyled.navbar-sidebar");
    if (mobileNavList) mobileNavList.style.display = "none";

    // Disable logo link (block navigation to homepage)
    function disableLogoLinks() {
      var logoLinks = document.querySelectorAll(
        'a.header__logo-link, .header__logo a, a.logo, .navbar-brand, a[href="/"]'
      );
      logoLinks.forEach(function (link) {
        if (link.dataset.logoDisabled) return;
        link.dataset.logoDisabled = "true";
        link.removeAttribute("href");
        link.style.cursor = "default";
        link.style.pointerEvents = "none";
        link.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      });
    }

    disableLogoLinks();
    new MutationObserver(disableLogoLinks).observe(document.body, { childList: true, subtree: true });

    // Hide Recommended Products section
    var recStyle = document.createElement("style");
    recStyle.textContent =
      ".section-wrapper:has([product-recommendations]) { display: none !important; }";
    document.head.appendChild(recStyle);

    function hideRecommendedProducts() {
      document.querySelectorAll("[product-recommendations]").forEach(function (el) {
        var wrapper = el.closest(".section-wrapper") || el;
        wrapper.style.display = "none";
      });
    }

    hideRecommendedProducts();
    new MutationObserver(hideRecommendedProducts).observe(document.body, {
      childList: true,
      subtree: true
    });

    // Bottom padding on product pages
    if (pathname.includes("/products/")) {
      var padStyle = document.createElement("style");
      padStyle.textContent =
        "product-info .product__wrapper { padding-bottom: 80px !important; }";
      document.head.appendChild(padStyle);
    }
  }

});